import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { secondFlowsActions } from 'features/secondFlows';

const useSecondFlows = () => {
  const dispatch = useDispatch();
  const getSecondFlow = useCallback(() => dispatch(secondFlowsActions.getSecondFlow()), [dispatch]);
  const createSecondFlow = useCallback(second_flow => dispatch(secondFlowsActions.createSecondFlow(second_flow)), [dispatch]);
  const updateSecondFlow = useCallback(second_flow => dispatch(secondFlowsActions.updateSecondFlow(second_flow)), [dispatch]);
  const deleteSecondFlow = useCallback(() => dispatch(secondFlowsActions.deleteSecondFlow()), [dispatch]);
  const clearLocalActiveSecondFlow = useCallback(() => dispatch(secondFlowsActions.clearLocalActiveSecondFlow()), [dispatch]);

  return {
    getSecondFlow,
    createSecondFlow,
    updateSecondFlow,
    deleteSecondFlow,
    clearLocalActiveSecondFlow
  };
};

export default useSecondFlows;